// Lightweight tracking helpers — push to window.dataLayer.
//
// GA4 + Google Ads are now handled ENTIRELY by GTM (container GTM-P9KCQTKH,
// see public/index.html). This file no longer injects any direct gtag call
// to a hardcoded Measurement ID — GTM reads the dataLayer events below and
// forwards them to the configured tags (respecting Consent Mode v2).

export function track(event, payload = {}) {
    if (typeof window === "undefined") return;
    try {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        window.dataLayer.push({ event, ...payload, ts: Date.now() });
    } catch (_) {
        // no-op
    }
}

/**
 * Fires a lead-conversion event on the dataLayer. GTM should be configured
 * with a Google Ads Conversion tag that triggers on this event.
 */
export function trackConversion(payload = {}) {
    if (typeof window === "undefined") return;
    try {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        window.dataLayer.push({
            event: "conversion",
            ...payload,
            ts: Date.now(),
        });
    } catch (_) {
        // no-op
    }
}

/**
 * Global click delegation — pushes `click_phone` for every `tel:` anchor and
 * `click_whatsapp` for every `wa.me` / `api.whatsapp.com` anchor, regardless
 * of the component that renders the link.
 *
 * Coexists with any per-component `track('phone_click' | 'whatsapp_click')`
 * call (different event names on purpose).
 *
 * Idempotent — call it at most once per page load.
 */
let _globalClickInstalled = false;
export function installGlobalClickTracking() {
    if (typeof window === "undefined" || typeof document === "undefined") return;
    if (_globalClickInstalled) return;
    _globalClickInstalled = true;

    const handler = (evt) => {
        const target = evt.target;
        if (!target || typeof target.closest !== "function") return;
        const anchor = target.closest("a[href]");
        if (!anchor) return;
        const href = anchor.getAttribute("href") || "";
        if (!href) return;

        if (href.startsWith("tel:")) {
            try {
                (window.dataLayer = window.dataLayer || []).push({
                    event: "click_phone",
                });
            } catch (_) { /* no-op */ }
            return;
        }

        // Match wa.me/... or api.whatsapp.com/... — protocol-agnostic.
        if (/(^|\/\/)(www\.)?(wa\.me|api\.whatsapp\.com)/i.test(href)) {
            try {
                (window.dataLayer = window.dataLayer || []).push({
                    event: "click_whatsapp",
                });
            } catch (_) { /* no-op */ }
        }
    };

    // Capture phase → we run before any component-level handler stops
    // propagation, so we never lose a click.
    document.addEventListener("click", handler, true);
}
